// Script pour mettre à jour les prix Klarna lors du changement de variante - Theme Concept
document.addEventListener('DOMContentLoaded', function() {
  
  // Fonction pour formater le prix selon le thème Shopify
  function formatMoney(cents) {
    // Utilise la fonction native du thème si disponible et si les settings sont chargés
    if (window.theme && theme.Currency && theme.Currency.formatMoney && window.themeVariables && themeVariables.settings) {
      try {
        return theme.Currency.formatMoney(cents, themeVariables.settings.moneyFormat);
      } catch (e) {
        // Fallback en cas d'erreur
      }
    }
    
    // Fallback simple
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }
  
  // Fonction pour ajouter l'effet de changement au prix principal
  function addPriceChangeEffect() {
    const priceElement = document.querySelector('.price__regular');
    const buyPriceElement = document.querySelector('product-buy-price');
    
    // Effet sur le prix principal
    if (priceElement) {
      priceElement.classList.remove('changed');
      priceElement.offsetHeight; // Force reflow
      setTimeout(() => {
        priceElement.classList.add('changed');
      }, 10);
      setTimeout(() => {
        priceElement.classList.remove('changed');
      }, 1000);
    }
    
    // Effet sur product-buy-price
    if (buyPriceElement) {
      buyPriceElement.classList.remove('changed');
      buyPriceElement.offsetHeight; // Force reflow
      setTimeout(() => {
        buyPriceElement.classList.add('changed');
      }, 10);
      setTimeout(() => {
        buyPriceElement.classList.remove('changed');
      }, 1000);
    }
  }
  
  // Fonction pour mettre à jour les prix Klarna
  function updateKlarnaPrices(priceInCents, showEffect = true) {
    // Ajouter l'effet visuel seulement si demandé
    if (showEffect) {
      addPriceChangeEffect();
    }
    
    // Calcul pour 3x
    const dividedPrice = priceInCents / 3.0;
    const remainder = priceInCents % 3;
    
    // Mise à jour du prix 3x
    const klarna3xElement = document.getElementById('klarna-3x-price');
    if (klarna3xElement) {
      if (remainder === 0) {
        klarna3xElement.textContent = formatMoney(Math.round(dividedPrice)) + ' x3';
      } else {
        const part1 = Math.floor(dividedPrice);
        const part2 = Math.ceil(dividedPrice);
        const remainingPayments = 3 - remainder;
        klarna3xElement.textContent = `${formatMoney(part2)} x${remainder} + ${formatMoney(part1)} x${remainingPayments}`;
      }
    }
    
    // Mise à jour du prix 4x
    const klarna4xElement = document.getElementById('klarna-4x-price');
    if (klarna4xElement) {
      const price4x = priceInCents / 4;
      klarna4xElement.textContent = formatMoney(Math.round(price4x)) + ' x4';
    }
  }
  
  // Variable globale pour stocker le prix actuel
  let currentPrice = 0;
  
  // Fonction pour récupérer la variante sélectionnée depuis le JSON
  function getSelectedVariantData() {
    const variantScript = document.querySelector('script[data-selected-variant]');
    if (variantScript) {
      try {
        return JSON.parse(variantScript.textContent);
      } catch (e) {
        return null;
      }
    }
    return null;
  }
  
  // Initialisation du prix au chargement
  function initPrice() {
    const selectedVariant = getSelectedVariantData();
    if (selectedVariant && selectedVariant.price) {
      currentPrice = selectedVariant.price;
      updateKlarnaPrices(currentPrice, false); // Pas d'effet au chargement initial
    }
  }
  
  // Écouter les changements directement sur les inputs radio
  function initDirectListener() {
    const variantPicker = document.querySelector('variant-selects');
    
    if (variantPicker) {
      // Écouter tous les changements sur variant-selects
      variantPicker.addEventListener('change', function() {
        setTimeout(() => {
          const newVariantData = getSelectedVariantData();
          if (newVariantData && newVariantData.price && newVariantData.price !== currentPrice) {
            currentPrice = newVariantData.price;
            updateKlarnaPrices(currentPrice);
          }
        }, 200);
      });
      
      // Écouter aussi spécifiquement les inputs radio
      const radioInputs = variantPicker.querySelectorAll('input[type="radio"]');
      radioInputs.forEach(input => {
        input.addEventListener('change', function() {
          setTimeout(() => {
            const newVariantData = getSelectedVariantData();
            if (newVariantData && newVariantData.price !== currentPrice) {
              currentPrice = newVariantData.price;
              updateKlarnaPrices(currentPrice);
            }
          }, 100);
        });
      });
    }
  }
  
  // Utilisation du système pubsub natif du thème
  function initPubSubListener() {
    if (window.theme && theme.pubsub && theme.pubsub.subscribe) {
      // S'abonner à l'événement de changement de variante
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function(data) {
        if (data && data.data && data.data.variant && data.data.variant.price) {
          const newPrice = data.data.variant.price;
          if (newPrice !== currentPrice) {
            currentPrice = newPrice;
            updateKlarnaPrices(currentPrice);
          }
        }
      });
      
      // S'abonner aussi à optionValueSelectionChange
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, function() {
        setTimeout(() => {
          const newVariantData = getSelectedVariantData();
          if (newVariantData && newVariantData.price !== currentPrice) {
            currentPrice = newVariantData.price;
            updateKlarnaPrices(currentPrice);
          }
        }, 200);
      });
    }
  }
  
  // Écouter les événements sur le form product
  function initFormListener() {
    const productForm = document.querySelector('form[is="product-form"]');
    if (productForm) {
      productForm.addEventListener('variant:change', function(event) {
        if (event.detail && event.detail.variant && event.detail.variant.price) {
          const newPrice = event.detail.variant.price;
          if (newPrice !== currentPrice) {
            currentPrice = newPrice;
            updateKlarnaPrices(currentPrice);
          }
        }
      });
    }
  }
  
  // Observer les changements dans le script JSON
  function initDOMObserver() {
    const variantScript = document.querySelector('script[data-selected-variant]');
    if (variantScript) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            const newVariantData = getSelectedVariantData();
            if (newVariantData && newVariantData.price !== currentPrice) {
              currentPrice = newVariantData.price;
              updateKlarnaPrices(currentPrice);
            }
          }
        });
      });
      
      observer.observe(variantScript, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }
  
  // Attendre que le thème soit chargé
  const initializeWhenReady = () => {
    // Vérifier que les éléments essentiels sont présents
    const klarnaElements = document.getElementById('klarna-3x-price') || document.getElementById('klarna-4x-price');
    if (!klarnaElements) {
      setTimeout(initializeWhenReady, 100);
      return;
    }
    
    initPrice();
    initDirectListener();
    initPubSubListener();
    initFormListener();
    initDOMObserver();
  };
  
  // Démarrer l'initialisation quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initializeWhenReady, 100);
    });
  } else {
    setTimeout(initializeWhenReady, 100);
  }
  
  // Export de la fonction pour utilisation externe
  window.updateKlarnaPrices = updateKlarnaPrices;
  
});